export interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  display_name?: string;
  title?: string;
  phone?: string;
  timezone: string;
  language: string;
  status: UserStatus;
  user_type: UserType;
  email_verified: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  last_login?: string;
  invited_at?: string;
  invited_by?: string;
  full_name: string;
  initials: string;
  roles: Role[];
  permissions: string[];
}

export interface UserSummary {
  id: string;
  full_name: string;
  initials: string;
  title: string | null;
}

export interface Role {
  id: string;
  name: string;
  display_name: string;
  description?: string;
  color: string;
  icon?: string;
  priority: number;
  is_system: boolean;
  is_system_role: boolean; // For backward compatibility
  is_active: boolean;
  is_default: boolean;
  parent_role_id?: string;
  created_at: string;
  updated_at: string;
  permissions?: Permission[];
  all_permissions: string[];
  user_count: number;
}

export interface Permission {
  id: string;
  name: string;
  display_name: string;
  description?: string;
  module: string;
  action: string;
  resource_type?: string;
  is_system: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INVITED = 'INVITED',
  PENDING = 'PENDING',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
}

enum UserType {
  ADMIN = 'ADMIN',
  INVESTOR = 'INVESTOR',
  AUDITOR = 'AUDITOR',
}

export interface UserFormData {
  email: string;
  first_name: string;
  last_name: string;
  title?: string;
  role_ids: string[];
}

export interface UserInviteData {
  email: string;
  first_name: string;
  last_name: string;
  title?: string;
  role_ids: string[];
  message?: string;
}

export interface UsersList {
  users: User[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface RolesList {
  roles: Role[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface UserStats {
  total_users: number;
  active_users: number;
  invited_users: number;
  pending_users: number;
  inactive_users: number;
  users_by_role: Record<string, number>;
  recent_logins: number;
}

export interface PermissionMatrix {
  modules: string[];
  actions: string[];
  permissions: Permission[];
}

export interface RolePermissionMatrix {
  role: Role;
  matrix: PermissionMatrix;
}
